import { EnvironmentInterface } from "@core/interface/environment.interface";

import { majetokEnvironment } from './products/majetok/environment.test';
import { TravelEnvironment } from './products/travel/environment.test';
import { LifeEnvironment } from "./products/life/environment.test";
import { KaskoEnvironment } from "./products/kasko/environment.test";
import { langInstances } from 'environments/products/lang-instances';
import { PzpEnvironment } from "./products/pzp/environment.test";
import { ZodpovednostEnvironment } from "./products/zodpovednost/environment.test";
import { KaskoKrupobitieEnvironment } from "./products/kasko-krupobitie/environment.test";


export const environment: EnvironmentInterface = {
    production: false,
    productsConfig: {
        majetok: majetokEnvironment,
        travel: TravelEnvironment,
        kasko: KaskoEnvironment,
        'kasko-krupobitie': KaskoKrupobitieEnvironment,
        pzp: PzpEnvironment,
        zodpovednost: ZodpovednostEnvironment,
        life: LifeEnvironment
    },
    googleMapsAPI: "",
    langInstance: "sk",
    langInstanceConfig: langInstances['sk']
};